import React from 'react';
import PropTypes from 'prop-types';

const TextQuestion = ({ question, value, onChange, error }) => {
  return (
    <input
      type="text"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className={`form-control form-control-sm${error ? ' is-invalid' : ''}`}
    />
  );
};

TextQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default TextQuestion;